import type { Jogador } from '../../jogadores/api/jogadores';
import { ITENS, svg } from '../../participantes/ui/MenuDeAcoes';
import type { ItemDoMenu } from '../../participantes/ui/MenuDeAcoes';

/**
 * As ações do menu da linha (`lider` = "Definir liderança") e o "Alocar" do campo do modal.
 * `pontuacao` ("Ver pontuação", `DP-RA-010`) abre a nota de cada fase do jogador.
 */
export type AcaoDaLinha = 'inativar' | 'reativar' | 'lider' | 'desfazer' | 'alocar' | 'pontuacao' | 'excluir';

export const SITUACAO: Record<Jogador['situacao'], string> = {
    ativo: 'Ativo',
    inativo: 'Inativo',
    bloqueado: 'Bloqueado',
};

const ITEM_LIDER: ItemDoMenu<AcaoDaLinha> = {
    chave: 'lider',
    rotulo: 'Definir liderança',
    icone: svg(<path d="M3 8l4 4 5-7 5 7 4-4-2 11H5L3 8z" />),
};

const ITEM_DESFAZER: ItemDoMenu<AcaoDaLinha> = {
    chave: 'desfazer',
    rotulo: 'Desfazer liderança',
    icone: svg(<path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5" />),
};

const ITEM_PONTUACAO: ItemDoMenu<AcaoDaLinha> = {
    chave: 'pontuacao',
    rotulo: 'Ver pontuação',
    icone: svg(<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3z" />),
};

const ITEM_EXCLUIR: ItemDoMenu<AcaoDaLinha> = {
    chave: 'excluir',
    rotulo: 'Excluir definitivamente',
    icone: svg(<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />),
    perigo: true,
};

/**
 * O menu na ordem do modelo (`img_1.png`): a situação; "Ver pontuação" (`DP-RA-010`); a liderança; e "Excluir definitivamente" por último, para ativo, inativo e bloqueado
 * (`DP-RA-043`). "Definir liderança" só para quem está ativo e ainda não é líder — inativo e bloqueado
 * nunca (`DP-RA-035`); "Desfazer liderança" só para o líder ativo e só quando a tabela mostra outro
 * membro ativo (`RN-RA-043`, `DP-RA-050`: o servidor recusa o mesmo caso com `409 sem_substituto_ativo`).
 */
export function itensDaLinha(jogador: Jogador, membros: Jogador[]): ItemDoMenu<AcaoDaLinha>[] {
    const situacao: ItemDoMenu<AcaoDaLinha> =
        jogador.situacao === 'inativo' ? { chave: 'reativar', ...ITENS.reativar } : { chave: 'inativar', ...ITENS.inativar };
    let lideranca: ItemDoMenu<AcaoDaLinha>[] = [];
    if (jogador.situacao === 'ativo' && !jogador.lider) lideranca = [ITEM_LIDER];
    else if (jogador.situacao === 'ativo' && outroAtivo(jogador, membros)) lideranca = [ITEM_DESFAZER];
    return [situacao, ITEM_PONTUACAO, ...lideranca, ITEM_EXCLUIR];
}

/** Há outro membro ativo no grupo de `jogador`, nos dados que a tela já tem. */
export function outroAtivo(jogador: Jogador, membros: Jogador[]): boolean {
    return membros.some(
        (membro) => membro.id !== jogador.id && membro.grupo_id === jogador.grupo_id && membro.situacao === 'ativo',
    );
}
